/**
 * LegalFooter - the imprint, privacy policy and terms on every page of
 * account.orboto.io, public and signed in.
 *
 * Imprint and privacy policy are the orboto.io pages (`/legal/imprint`,
 * `/legal/privacy`); the privacy policy's scope names the Customer Portal, so
 * one text serves both and cannot drift. They open in the same tab: they are
 * orboto's own pages, not a third-party site. The terms link stays inside the
 * portal (`/terms`).
 *
 * The DB-IP credit (OCP-848): the api resolves the country of a login, a
 * signup session and a code redemption from DB-IP's IP to Country Lite
 * database (CC BY 4.0). The credit is plain text, not a link - no element of
 * the portal leads the customer to a third-party site (operator decision
 * 2026-10-17). The wording is DB-IP's own snippet and stays as is in every
 * locale.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const IMPRINT_URL = 'https://orboto.io/legal/imprint';
export const PRIVACY_URL = 'https://orboto.io/legal/privacy';

export function LegalFooter({ className = '' }: { className?: string }) {
  const { t } = useTranslation('common');
  const link = 'hover:text-brand-500 hover:underline';
  return (
    <footer data-testid="legal-footer" className={`text-center text-[11px] text-gray-400 dark:text-gray-500 ${className}`}>
      <nav aria-label={t('legal.aria')} className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <a href={IMPRINT_URL} className={link}>
          {t('legal.imprint')}
        </a>
        <a href={PRIVACY_URL} className={link}>
          {t('legal.privacy')}
        </a>
        <Link to="/terms" className={link}>
          {t('legal.terms')}
        </Link>
      </nav>
      <p data-testid="geoip-attribution" className="mt-1">
        IP Geolocation by DB-IP
      </p>
    </footer>
  );
}
